<div class="tw-flex tw-h-full tw-flex-col tw-gap-3">
  <!-- Stage Content -->
  <div class="tw-flex-1">
    <!-- File Details Stage -->
    <app-file-details-stage
      *ngIf="stageInfo().isFileDetailsStage"
      [uploadedFileName]="uploadedFileName"
      [statementFromDate]="statementFromDate"
      [statementToDate]="statementToDate"
      (fileNameChange)="onFileNameChange($event)"
      (statementDatesSelected)="onStatementDatesSelected($event)"
    ></app-file-details-stage>

    <!-- Select Account Stage -->
    <app-select-account-stage
      *ngIf="stageInfo().isSelectAccountStage"
      [statementFromDate]="statementFromDate"
      [statementToDate]="statementToDate"
      [prefill]="prefill"
      (accountsSelected)="onAccountsSelected($event)"
    ></app-select-account-stage>

    <!-- Add Transaction Stage -->
    <app-add-transaction-stage
      *ngIf="stageInfo().isAddTransactionStage"
      [linkedAccounts]="getLinkedAccounts()"
      [prefillTransactions]="transactions"
      (transactionsChanged)="onTransactionsChanged($event)"
    ></app-add-transaction-stage>
  </div>

  <!-- Action Buttons -->
  <div
    class="tw-flex tw-justify-between tw-gap-3 tw-border-0 tw-border-t tw-border-color-border-subtle tw-pt-4 sm:tw-flex-col sm:tw-justify-start"
  >
    <!-- Left side: Back button. Hidden on mobile (sm), where the modal header shows it instead. -->
    <app-gloss-button
      *ngIf="stageInfo().isSelectAccountStage || stageInfo().isAddTransactionStage"
      class="sm:tw-hidden"
      [options]="backButtonOptions"
    ></app-gloss-button>

    <!-- Right side buttons -->
    <div class="tw-flex tw-gap-3 tw-ml-auto sm:tw-ml-0 sm:tw-w-full sm:tw-flex-col sm:tw-items-end">
      <!-- File Details Stage: Next button -->
      <app-gloss-button
        *ngIf="stageInfo().isFileDetailsStage"
        [options]="nextButtonOptions"
      ></app-gloss-button>

      <!-- Select Account Stage: Save and add later + Add Transaction buttons (full-width when stacked) -->
      <app-gloss-button
        *ngIf="stageInfo().isSelectAccountStage"
        class="sm:tw-w-full"
        [options]="saveAndAddLaterButtonOptions"
      ></app-gloss-button>
      <app-gloss-button
        *ngIf="stageInfo().isSelectAccountStage"
        class="sm:tw-w-full"
        [options]="addTransactionButtonOptions"
      ></app-gloss-button>

      <!-- Add Transaction Stage: Complete button -->
      <app-gloss-button
        *ngIf="stageInfo().isAddTransactionStage"
        [options]="completeButtonOptions"
      ></app-gloss-button>
    </div>
  </div>
</div>
